var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotBrakListy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 240,
    viewBox: "0 0 260 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 40.842,
    height: 6.391,
    x: 130.684,
    y: 87.087,
    rx: 3.195
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 63.816,
    height: 63.908,
    x: 113.454,
    y: 36.074,
    rx: 5.76
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 110,
    height: 133,
    x: 90,
    y: 109,
    rx: 5.184
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#81E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4AC2EE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "e",
    cx: 9.16,
    cy: 8.408,
    rx: 8.296,
    ry: 8.308
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M-9.985-1.817H.226v19.172H-9.985z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "h",
    cx: 8.977,
    cy: 9.288,
    rx: 8.296,
    ry: 8.308
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M-10.168-.937H.043v19.172h-10.211z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.202,
    height: 5.751,
    x: 131.004,
    y: 87.407,
    stroke: "#979797",
    strokeWidth: 0.64,
    rx: 2.875
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7DD8FA",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.816,
    height: 63.908,
    x: 113.454,
    y: 36.074,
    rx: 5.76
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303556",
    strokeWidth: 25.6,
    d: "M104.384 115.808c-3.009 20.936-14.01 32.068-33.003 33.396-18.993 1.328-33.727-10.916-44.201-36.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    stroke: "#F7465F",
    strokeWidth: 0.512,
    d: "M49.335 96.47c-.48-.42-1.264-.428-2.352-.022L3.36 107.324c-1.098.066-1.897.468-2.396 1.207-.75 1.107-.341 1.479-.013 2.355 5.42 14.486 15.503 19.89 30.25 16.214 14.504-3.616 20.9-12.873 19.188-27.77-.134-1.164-.335-2.229-1.054-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303556",
    strokeWidth: 25.6,
    d: "M232.636 70.31c15.424 14.474 18.233 29.87 8.427 46.19-9.806 16.32-29.066 21.517-57.779 15.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    stroke: "#F7465F",
    strokeWidth: 0.512,
    d: "M236.735 41.3c-.905-.039-1.798.495-2.68 1.6l-25.577 36.528c-.559.914-.684 1.835-.375 2.763.464 1.39.87 1.275 2.017 1.862 13.183 6.746 24.033 4.037 32.55-8.126 8.424-12.032 7.376-23.044-3.146-33.038-1.042-.99-1.432-1.53-2.789-1.589z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4AC2EE",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 133,
    x: 90,
    y: 109,
    rx: 5.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 75,
    x: 114,
    y: 138,
    fill: "url(#d)",
    rx: 5.184
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 327.092 -564.161)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#303556",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeWidth: 0.64,
    d: "M-9.665-1.497h9.571v18.532h-9.571z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M9.346.382h10.211v19.172H9.346z",
    mask: "url(#f)",
    transform: "rotate(12 14.452 9.968)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-14 134.262 725.95)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#303556",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeWidth: 0.64,
    d: "M-9.848-.617h9.571v18.532h-9.571z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M-1.905-.902H8.306V18.27H-1.905z",
    mask: "url(#i)",
    transform: "rotate(14 3.2 8.685)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#303556",
    d: "M148.423 80.856h18.573a4.8 4.8 0 0 0 1.503-.241c.911-.3 1.717.118 2.418 1.255.581.945.52 2.611-.183 5-.005.017-.06.168-.163.454a4.8 4.8 0 0 1-4.29 3.163c-8.64.403-14.238.348-16.794-.163-.662-.132-1.54-.403-2.633-.813a4.47 4.47 0 0 1 1.569-8.655z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 65.075 780.935)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#303556",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.991 14.338l4.135 21.766"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.039,
    cy: 8.777,
    fill: "#F7465F",
    rx: 8.296,
    ry: 8.308
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotBrakListy);
export default __webpack_public_path__ + "static/media/robot-brak-listy.6a606f648c39788a570e06941674956a.svg";
export { ForwardRef as ReactComponent };